import * as React from 'react'
import {Container} from '@mui/material'
import {useNavigate} from 'react-router-dom'


const Header = ({children})=>{

  const navigate = useNavigate()

	return(
      <Container style={{display:"flex",flexDirection:"row",marginBottom:10}}>
          {children}
      </Container>
		)
}

export default Header;